module.exports = __webpack_public_path__ + "static/media/terrible.2b0e383f.png";